import axios from "../axios";

class TestAdminService {

  static Instance() {
    return new TestAdminService();
  }

  runRefetchDataScheduler() {
    return axios.post("/api/admin/run/searatesRefetchDataScheduler");
  }

  runRetryFailureScheduler() {
    return axios.post("/api/admin/run/searatesRetryFailureScheduler");
  }

  startSeaRatesTrackingByCT(containerNum) {
    return axios.post(`/api/admin/start/searatesTrackingByCT?containerNum=${encodeURIComponent(containerNum)}`);
  }

  startSearatesTrackingByBL(containerNumBL, blNum, sealine) {
    return axios.post(`/api/admin/start/searatesTrackingByBL?containerNum=${encodeURIComponent(containerNumBL)}&blNum=${encodeURIComponent(blNum)}&sealine=${encodeURIComponent(sealine)}`);
  }

  readOneStopEmails() {
    return axios.post("/api/admin/read/onestopEmails");
  }

  /*
  copyBlobContainerData(source, dest) {
    return axios.post(`/api/admin/copy/blobContainerData?source=${source}&dest=${dest}`, null, { timeout: 3600000 });
  }

  moveBlobContainerData(source, dest) {
    return axios.post(`/api/admin/move/blobContainerData?source=${source}&dest=${dest}`, null, { timeout: 3600000 });
  }
  */

}

export default TestAdminService.Instance();